import { Box, useTheme, useMediaQuery } from '@mui/material';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import PageTitle from '../../../components/shared/PageTitle';
import PageArea from '../../../components/shared/PageArea';
import { UserContext } from '../../../components/shared/useUser';
import PermissionsTab from './components/PermissionsTab';

const PermissionsPage = () => {
  const { t } = useTranslation('admin');

  const { hasPermissionTo } = useContext(UserContext);

  const canView = hasPermissionTo(['PermissionView']);

  if (!canView) {
    return null;
  }

  return (
    <PageArea>
      <Box>
        <PageTitle subTitle={t('permissions.subtitle')}>{t('permissions.title')}</PageTitle>
      </Box>

      <PermissionsTab />
    </PageArea>
  );
};

export default PermissionsPage;
